import { LitElement, css, html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { durationToHuman } from '../lib/utils.js';

@customElement('app-timer')
export class Timer extends LitElement {
  static styles = css``;

  @property({ type: Date }) startedAt = '';
  @property({ type: Date }) endsAt = '';
  @property({ type: Number }) size;

  @state() elapsedTime = '';

  setElapsedTimeString() {
    if(this.endsAt) {
      this.elapsedTime = durationToHuman(this.endsAt - new Date(), {size: this.size, invert: true});
    } else {
      this.elapsedTime = durationToHuman(new Date() - this.startedAt, {size: this.size});
    }
  }

  startTimer() {
    this.setElapsedTimeString();
    this.interval = setInterval(() => {
      this.setElapsedTimeString();
    }, 1000);
  }

  stopTimer() {
    clearInterval(this.interval);
  }

  connectedCallback() {
    super.connectedCallback();
    this.startTimer();
  }

  render() {
    return html`${this.elapsedTime}`;
  }
}

